<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-06-15 11:42:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 11:16:59
-->
<template>
  <div
    class="page_container"
    :style="{
      'background-color': pageConfig.bgColor,
      backgroundImage: pageConfig.bgImg ? 'url(' + pageConfig.bgImg + ')' : '',
    }"
  >
    <div class="f-1">
      <!-- <select-store-entrance @sendVpnId="sendVpnId"></select-store-entrance> -->
      <!-- 动态组件 -->
      <component
        :is="item.component"
        v-for="(item, index) in pageComponents"
        :key="index"
        :datas="item.setStyle"
        class="components_class"
      >
      </component>
    </div>

    <myFooter></myFooter>
  </div>
</template>

<script>
// import { pageModuleArr, pageConfig } from "@/utils/testJson";
import { getWetWechatCustomPage } from "@/api/member";
import wxConfig from "@/utils/wxConfig.js";
import myFooter from "@/components/myFooter";
export default {
  name: "CustomHomePage",
  props: {},

  components: { myFooter },
  data() {
    return {
      pageComponents: [],
      pageConfig: {},
    };
  },

  created() {},
  watch: {
    "$route.query.page"(val) {
      this.pageType = val;
      this.handleGetWetWechatCustomPageConfig();
    },
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log("to===", to.name);
  //   console.log("from.name ===", from.name);
  //   console.log("from ===", from);
  //   next((vm) => {
  //     if (vm.$route.query.page == 1) {
  //       vm.$route.meta.title = "首页";
  //     } else if (vm.$route.query.page == 2) {
  //       vm.$route.meta.title = "个人中心";
  //     }
  //   });
  // },
  mounted() {
    // 重定向之前的原页面路径
    this.pageOriginUrl = this.$route.redirectedFrom;
    this.pageType = this.$route.query.page || 1;
    this.handleGetWetWechatCustomPageConfig();
    // this.pageComponents = pageModuleArr;
    // console.log(pageModuleArr);
  },
  updated() {},
  methods: {
    handleGetWetWechatCustomPageConfig() {
      getWetWechatCustomPage({
        VpnNumber: this.$store.state.vpnNumber,
        Page: this.pageType,
      }).then((res) => {
        if (res) {
          const configData = res[0];
          if (configData.Info) {
            this.pageConfig = JSON.parse(configData.Info);
            if (this.pageConfig.shareTitle) {
              // 分享时拼接 重定向之前的原页面路径
              const pageBaseUrl = location.href.split("#")[0];
              wxConfig.WeChatShare(
                this,
                pageBaseUrl + "#" + this.pageOriginUrl,
                this.pageConfig.shareTitle,
                this.pageConfig.shareImg,
                this.pageConfig.shareDetails
              );
            }
            // this.$route.meta.title = this.pageConfig.name;
          }
          // if (res.Info) {
          // this.pageConfig = JSON.parse(res.Info);
          // if (this.pageConfig.shareTitle) {
          //   wxConfig.WeChatShare(
          //     this,
          //     location.href,
          //     this.pageConfig.shareTitle,
          //     this.pageConfig.shareImg,
          //     this.pageConfig.shareDetails
          //   );
          // }
          // }
          if (configData.Body) {
            this.pageComponents = JSON.parse(configData.Body);
          } else {
            this.pageComponents = [];
          }
        } else {
          this.pageComponents = [];
        }
      });
    },
    // sendVpnId(val) {
    //   this.vpnId = val;
    // },
  },
};
</script>
<style scoped lang="scss">
.page_container {
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  min-height: calc(100vh - 100px - env(safe-area-inset-bottom));
}
.components_class {
  // margin: 10px 0;
  overflow: hidden;
}
</style>
